import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import type { AnimationDirection } from '../../types';

interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: AnimationDirection;
}

const HIDDEN_CLASSES: Record<AnimationDirection, string> = {
  up: 'opacity-0 translate-y-10',
  left: 'opacity-0 -translate-x-10',
  right: 'opacity-0 translate-x-10',
  fade: 'opacity-0',
};

export default function AnimatedSection({
  children,
  className = '',
  delay = 0,
  direction = 'up',
}: AnimatedSectionProps) {
  const { ref, visible } = useScrollAnimation();

  return (
    <div
      ref={ref}
      className={`transition-[opacity,transform] duration-700 ease-out ${visible ? 'opacity-100 translate-y-0 translate-x-0' : HIDDEN_CLASSES[direction]} ${className}`}
      style={{
        transitionDelay: visible ? `${delay}ms` : '0ms',
        willChange: visible ? 'auto' : 'opacity, transform',
      }}
    >
      {children}
    </div>
  );
}
